import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import ElementDataRow from 'components/common/element-data/ElementDataRow';
import { ElementMetadataFieldName, IElementDataDescription } from 'components/common/element-data/types';
import ElementDataRowValue from 'components/common/element-data/ElementDataRowValue';
import useBundleTranslation from 'i18n';
import styles from '../ElementData.styles';
import { getFieldElementMetadataSettings } from 'components/common/element-data/functions';
import { useTheme } from '@mui/material/styles';

export default function Description(props: IElementDataDescription) {
    const { t } = useBundleTranslation(['components/common/element_data']);
    const {
        descriptionMaxRows = 5,
        description = '',
        descriptionMarkdownInd = false,
        descriptionMarkdown = '',
        settings,
    } = props;
    const appTheme = useTheme();
    const fieldKey: ElementMetadataFieldName = 'description';
    const { fieldMetadataDisplay, fieldMetadataOrder } = getFieldElementMetadataSettings(settings, fieldKey);

    const [descriptionCut, setDescriptionCut] = useState<boolean>(false);
    const [descriptionExpand, setDescriptionExpand] = useState<boolean>(false);
    const descriptionContentRef = React.useRef<HTMLDivElement>(null);

    const maxDescContainerHeight =
        descriptionMaxRows * appTheme.size.lineHeight * (appTheme.typography.topBarMenu.fontSize as number);

    useEffect(() => {
        if (descriptionContentRef.current) {
            setDescriptionCut(descriptionContentRef.current.clientHeight > maxDescContainerHeight);
        }
    }, [descriptionContentRef.current]);

    if (!fieldMetadataDisplay || !description) return null;

    return (
        <ElementDataRow order={fieldMetadataOrder}>
            <ElementDataRowValue>
                <Box
                    className={'element-description-container'}
                    sx={{
                        ...styles.descriptionContainer,
                        maxHeight: descriptionCut && !descriptionExpand ? `${maxDescContainerHeight}px` : 'none',
                    }}
                >
                    <Box
                        className={'element-description-holder'}
                        ref={descriptionContentRef}
                        sx={styles.descriptionHolder}
                    >
                        {descriptionMarkdownInd ? (
                            <Box
                                className={'markdown-holder'}
                                dangerouslySetInnerHTML={{
                                    __html: descriptionMarkdown,
                                }}
                            />
                        ) : (
                            description
                        )}
                    </Box>
                </Box>
                {descriptionCut && (
                    <Box
                        className={'element-description-expand-control'}
                        onClick={() => {
                            setDescriptionExpand(!descriptionExpand);
                        }}
                        sx={styles.descriptionExpandControl}
                    >
                        {descriptionExpand
                            ? t('element_data_common.description_show_less')
                            : t('element_data_common.description_show_more')}
                    </Box>
                )}
            </ElementDataRowValue>
        </ElementDataRow>
    );
}
